import { ClearRounded } from '@mui/icons-material'
import { CircularProgress, IconButton } from '@mui/material'
import { useConfirm } from 'material-ui-confirm'
import React from 'react'
import { SkillBiteEditSlice } from '../../../../../reducers'
import { useSelector } from 'react-redux'
import { useEvent } from '@emerald-works/react-event-bus-client'

const DeleteSection = ({ className, loadingClassName, section, sessionId }) => {
  const confirm = useConfirm()
  const skillBite = useSelector(SkillBiteEditSlice.selectors.selectSkillBite)

  const [deleteSection] = useEvent([SkillBiteEditSlice.eventBus.deleteSection])

  const handleDeleteSection = (evt) => {
    evt.preventDefault()
    evt.stopPropagation()
    confirm({
      title: 'Delete section',
      description: 'This is a destructive action. Are you sure you want to delete this section?',
      confirmationText: 'Yes, delete it.',
      confirmationButtonProps: {
        id: 'delete-section-confirmation-button',
        'data-test': 'delete-section-confirmation-button'
      },
      cancellationText: 'No, thanks.',
      cancellationButtonProps: {
        id: 'delete-section-cancellation-button',
        'data-test': 'delete-section-cancellation-button'
      },
      dialogProps: {
        PaperProps: {
          id: 'delete-section-confirmation-modal',
          'data-test': 'delete-section-confirmation-modal'
        }
      },
      titleProps: {
        id: 'delete-section-confirmation-title',
        'data-test': 'delete-section-confirmation-title'
      }
    }).then(() => {
      deleteSection.trigger({ skillBiteId: skillBite.id, sessionId, sectionId: section.id })
    }).catch(err => {
      console.log('Delete section cancelled', err)
    })
  }

  let icon = <ClearRounded fontSize='small' color='error' />

  if (deleteSection.isWorking) {
    icon = <CircularProgress size='1em' />
  }

  return (
    <IconButton
      size='small'
      onClick={handleDeleteSection}
      sx={{ width: '30px', height: '30px' }}
      disabled={deleteSection.isWorking}
      className={deleteSection.isWorking ? loadingClassName : className}
    >
      {icon}
    </IconButton>
  )
}

export default DeleteSection
